﻿// scrollend emulation
import "scrollyfills";

function updateScrollProps() {
	// setting rootStyle to document.documentElement.style;
	// causes perf problems
	const rootStyle = document.getElementById("td-toptab")?.style;
	if (!rootStyle)
		return;
	const body = document.body;
	const header = document.getElementById("td-header");
	if (header) {
		const headerRect = header.getBoundingClientRect();
		rootStyle.setProperty("--v3-sys-header-visible-height", `${Math.max(0, headerRect.bottom)}px`);
	}
	const footer = document.getElementById("td-footer");
	if (footer) {
		const footerRect = footer.getBoundingClientRect();
		rootStyle.setProperty("--v3-sys-footer-visible-height", `${Math.min(Math.max(0, body.clientHeight - footerRect.top), footerRect.height)}px`);
	}
}

// sets the bottom intersection between the footer
function initHeaderFooterObservers() {
	const body = document.body;
	body.addEventListener("scroll", updateScrollProps);
}

function initBodyResizeObserver() {
	new ResizeObserver(([e]) => {
		const scrollbarWidth = window.innerWidth - e.target.clientWidth;
		const scrollbarHeight = window.innerHeight - e.target.clientHeight;
		const rootStyle = document.documentElement.style;
		rootStyle.setProperty("--v3-sys-scrollbar-width", `${scrollbarWidth}px`);
		rootStyle.setProperty("--v3-sys-scrollbar-height", `${scrollbarHeight}px`);
		updateScrollProps();
	}).observe(document.body);
}

function setupScrollBack(scrollView, scrollDelta = 16) {
	let lastTopScroll = scrollView.scrollTop;
	scrollView.addEventListener('scrollend', event => {
		const scrollView = event.target;
		const scrollTop = scrollView.scrollTop;
		if (scrollTop > lastTopScroll + scrollDelta) {
			lastTopScroll = scrollTop <= 0 ? 0 : scrollTop;
			scrollView.dispatchEvent(new Event("scrolldown"));

		} else {
			lastTopScroll = scrollTop <= 0 ? 0 : scrollTop;
			scrollView.dispatchEvent(new Event("scrollup"));
		}
	}, { passive: true });
}

function init() {
	// ^^^ called from ready
	initHeaderFooterObservers();
	initBodyResizeObserver();
	setupScrollBack(document.body);
}

export { init };